import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

import Button from 'components/ui/Button';
import { colours } from 'themes/default';

export const ButtonGroupContainer = styled.div`
  position: relative;
  display: inline-flex;
  vertical-align: middle;
`;

export const StyledButton = styled(Button)`
  position: relative;
  height: 40px;
  line-height: 40px;
  border: 1px solid ${colours.Greyscale.SilverGrey};
  background-color: ${colours.Greyscale.White};
  cursor: pointer;
  border-radius: 0;

  &:not(:first-of-type) {
    border-left: none;
  }

  div {
    line-height: 40px;
    color: ${colours.Greyscale.CharcoalGrey};
  }

  ${ifProp(
    'selected',
    css`
      background-color: ${colours.Greyscale.SilverGrey};

      &:hover {
        background-color: ${colours.Greyscale.SilverGrey};
      }
    `
  )}
`;
